// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container_Ow97b relative z-modal mx-auto my-[50px] px-5 pb-2.5 max-w-[660px] w-3/4 overflow-auto bg-white lg_mx-0 lg_pb-[26px] lg_max-h-full"};